import React from 'react';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1
  });
  const getDirectionClass = () => {
    switch (direction) {
      case 'up':
        return 'translate-y-8';
      case 'down':
        return '-translate-y-8';
      case 'left':
        return 'translate-x-8';
      case 'right':
        return '-translate-x-8';
      case 'none':
        return '';
      default:
        return 'translate-y-8';
    }
  };
  return <div ref={ref as any} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0 translate-x-0' : `opacity-0 ${getDirectionClass()}`} ${className}`} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-699" data-mp="2g8e9eqy7lb9z">
      {children}
    </div>;
}